import * as ActionTypes from '../actions/actionTypes';

const initialState = {
  panel_open: false,
  image_numbers: [[2, 3, 4, 5, 6, 7, 8, 9], [10, 11, 12, 13, 14, 15, 16, 17]],
  selected_number: 2
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TOGGLE_AQFX_PANEL:
      return {
        ...state,
        panel_open: !state.panel_open
      };

    case ActionTypes.SELECT_AQFX_NUMBER:
      return {
        ...state,
        selected_number: action.selected_number
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/aqfx.js